import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PlayVideo from "../../Play/custom-video";

import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import moment from 'moment'
import LeftArrow from '../../../images/CaretLeft.svg'; // Adjust the path if needed
import RightArrow from '../../../images/CaretRight.svg'; // Adjust the path if needed
import { useLocation } from "@reach/router";
import img01 from "../../../images/home/newsletter/img01.png"
import tab01 from "../../../images/home/newsletter/img02.png"
import tab02 from "../../../images/home/newsletter/img03.png"
import desk01 from "../../../images/home/newsletter/desk01.png"
import desk02 from "../../../images/home/newsletter/desk02.png"
import desk03 from "../../../images/home/newsletter/desk03.png"
import desk04 from "../../../images/home/newsletter/desk04.png"
//import ScrollAnimation from "react-animate-on-scroll";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import Slider from "react-slick";
import "./News.scss"
import { Link } from "@StarberryUtils";

import { LATEST_NEWS_PAGE_URL } from "../../common/site/constants";

const GET_ALL_NEWS = gql`
  query GetNews{	
    newsItems(sort:"Date:desc", limit:6)  {
        id
        ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
        }
        Content
        Title
        Date
        Embed_Video_URL
        Featured
        Meta_Description
        Meta_Title
        URL
        Tile_Image {
          alternativeText
          url
        }
        news_category {
          Name
          URL
        }
        imagetransforms
      }
  }
`;

const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={`${className} icon-arrow-left`} onClick={onClick}></div>
    );
  };
  
  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={`${className} icon-arrow-right`} onClick={onClick}></div>
    );
  };
  
const OtherNews = (props) => {
    let [isPlay, setPlay] = React.useState(false);
    const location = useLocation();
    const settings = {
        dots: true,
        lazyLoad: true,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    arrows: false,
                    //dots: false,
                    slidesToShow: 2,
                    slidesToScroll: 1 
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1 

                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            },
        ],
    }

    const { loading, error, data } = useQuery(GET_ALL_NEWS);

    if (loading) return <p class="loading-txt">Loading ...</p>; 
    const newsList = data?.newsItems.filter(list => list.id != props.newsId); 
    const heading = location.pathname.includes('/about-dacha/our-team/alessia-sheglova/') 
      ? "Recent Articles Written by Alessia Sheglova" 
      : "Other News & Insights";
      const para = location.pathname.includes('/about-dacha/our-team/alessia-sheglova/') 
      ? "Discover the latest insights from Alessia, CEO of Dacha Real Estate, in her recent article. She explores emerging trends, expert tips, and innovative strategies in the property market. Whether you're a seasoned investor or a first-time buyer, Alessia's expertise offers valuable guidance for making informed decisions." 
      : "";
    return (
        // <section className="news">
        <div animateIn='fadeInUp' animateOnce className="news other-news">
            {newsList && newsList.length > 0 &&
                <Container>
                    <h2>{heading}</h2>
                    <p className="text-sm">{para}</p>
                    <Slider  {...settings}>
                        {newsList.map((news, index, active) => {

                          const image_url = news?.Tile_Image?.url 

                          let processedImages = JSON.stringify({});
                          if (news?.imagetransforms?.Tile_Image_Transforms) {
                              processedImages = news.imagetransforms.Tile_Image_Transforms;
                          }

                            return (
                                <div className="all-products news-list">
                                    <div className="properties-wrapper img-zoom">
                                        {/* <ImageTransform 
                                        imagesources={image_url} 
                                        renderer="srcSet" 
                                        imagename="news-items.Tile_Image.tile_2" 
                                        attr={{ alt: news.Title+ ' - Dacha', class:'' }} 
                                        imagetransformresult={processedImages} 
                                        id={news.id}/> */}
                                        <ImageModule 
                                                ImageSrc={news?.Tile_Image } 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2" 
                                                strapi_id={news?.id} 
                                        />    
                                        {news.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={news.Embed_Video_URL}  />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        {news.Date &&
                                        <div className="time-info">
                                            <i className="icon-clock">
                                            </i>
                                            {moment(news.Date).format("DD/MM/YYYY")}
                                        </div>
                                        }
                                        <h4>
                                            <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}`}>
                                                {news.Title} 
                                            </Link>
                                        </h4>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </Container>
            }
            {/* <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoId="V8ksSGxo6no"
                isAutoPlay={1}
            /> */}
        </div>
    )
}
export default OtherNews